import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'

Vue.use(Router)
//require按需加载
const login = r => require.ensure([], () => r(require('../pages/login/login')), 'login');
const main = r => require.ensure([], () => r(require('../pages/Main')), 'main');
//园所
const kgList = r => require.ensure([], () => r(require('../pages/kindergarten/KgList')), 'kgList');
const kindergartenMain = r => require.ensure([], () => r(require('../pages/kindergarten/KindergartenMain')), 'kindergartenMain');
const kgHome = r => require.ensure([], () => r(require('../pages/kindergarten/KgHome')), 'kgHome');
const kgHomeNew = r => require.ensure([], () => r(require('../pages/kindergarten/KdgHomeNew')), 'kgHomeNew');
const childList = r => require.ensure([], () => r(require('../pages/kindergarten/ChildList')), 'childList');
const exportReport = r => require.ensure([], () => r(require('../pages/kindergarten/ExportReport')), 'exportReport');
const checkData = r => require.ensure([], () => r(require('../pages/kindergarten/CheckData')), 'checkData');
const kgTestReport = r => require.ensure([], () => r(require('../pages/kindergarten/KgTestReport')), 'kgTestReport');
const screeningChildren = r => require.ensure([], () => r(require('../pages/kindergarten/ScreeningChildren')), 'screeningChildren');
const familyReport = r => require.ensure([], () => r(require('../pages/kindergarten/FamilyReport')), 'familyReport');
const termOutline = r => require.ensure([], () => r(require('../pages/kindergarten/TermOutline')), 'termOutline');
const courseContent = r => require.ensure([], () => r(require('../pages/kindergarten/CourseContent')), 'courseContent');
const exercisePlan = r => require.ensure([], () => r(require('../pages/kindergarten/ExercisePlan')), 'exercisePlan');
const teacherManagement = r => require.ensure([], () => r(require('../pages/kindergarten/TeacherManagement')), 'teacherManagement');
const teachingProgram = r => require.ensure([], () => r(require('../pages/kindergarten/TeachingProgram')), 'teachingProgram');
const classHome = r => require.ensure([], () => r(require('../pages/kindergarten/ClassHome')), 'classHome');
const gradeHome = r => require.ensure([], () => r(require('../pages/kindergarten/GradeHome')), 'gradeHome');


//加盟商
const allianceList = r => require.ensure([], () => r(require('../pages/alliance/AllianceList')), 'allianceList');
const allianceMain = r => require.ensure([], () => r(require('../pages/alliance/AllianceMain')), 'allianceMain');
const allianceHome = r => require.ensure([], () => r(require('../pages/alliance/AllianceHome')), 'allianceHome');
const allianceHistoryList = r => require.ensure([], () => r(require('../pages/alliance/AllianceHistoryList')), 'allianceHistoryList');
const projectSpeed = r => require.ensure([], () => r(require('../pages/alliance/children/ProjectSpeed')), 'projectSpeed');
const projectInformation = r => require.ensure([], () => r(require('../pages/alliance/children/ProjectInformation')), 'projectInformation');

const resourceTelephone = r => require.ensure([], () => r(require('../pages/alliance/children/ResourceTelephone')), 'resourceTelephone');
const teacherPlatform = r => require.ensure([], () => r(require('../pages/alliance/children/TeacherPlatform')), 'teacherPlatform');
const kdgConnect = r => require.ensure([], () => r(require('../pages/alliance/children/KdgConnect')), 'kdgConnect');
const logInfo = r => require.ensure([], () => r(require('../pages/alliance/children/LogInformation')), 'logInfo');
const addEditKdg = r => require.ensure([], () => r(require('../pages/alliance/children/AddEditKdg')), 'addEditKdg');
const introduction = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/Introduction')), 'introduction');
const promotionalMaterials = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/PromotionalMaterials')), 'promotionalMaterials');
const governmentInfo = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/GovernmentInformation')), 'governmentInfo');
const activityScheme = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/ActivityScheme')), 'activityScheme');
const planScheme = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/PlanningScheme')), 'planScheme');
const testInstruction = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/TestInstructions')), 'testInstruction');
const systemUse = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/SystemUsageDescription')), 'systemUse');
const hardwareEquip = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/HardwareEquipment')), 'hardwareEquip');
const parentMeet = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/ParentsMeeting')), 'parentMeet');
const propagandaMater = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/PropagandaMaterials')), 'propagandaMater');
const packaging = r => require.ensure([], () => r(require('../pages/helpCenter/allianceHelp/Packaging')), 'packaging');
//机构
const agencyList = r => require.ensure([], () => r(require('../pages/agency/AgencyList')), 'agencyList');
const agencyHome = r => require.ensure([], () => r(require('../pages/agency/AgencyHome')), 'agencyHome');
const testersManagement = r => require.ensure([], () => r(require('../pages/agency/TestersManagement')), 'testersManagement');//代理+机构：测试员管理
//代理
const proxyList = r => require.ensure([], () => r(require('../pages/proxy/ProxyList')), 'proxyList');
const proxyHome = r => require.ensure([], () => r(require('../pages/proxy/ProxyHome')), 'proxyHome');
//导入
const importData = r => require.ensure([], () => r(require('../pages/import/ImportData')), 'importData');
//其他
const other = r => require.ensure([], () => r(require('../pages/other/Other')), 'other');
//课程
const course = r => require.ensure([], () => r(require('../pages/course/CoursePackageList')), 'course');
const kangarooCoursePackage = r => require.ensure([], () => r(require('../pages/course/KangarooCoursePackage'), 'kangarooCoursePackage'))
const kangarooCourseList = r => require.ensure([], () => r(require('../pages/course/KangarooCourseList'),'kangarooCourseList'));
const kangarooCoursePackageEdit = r => require.ensure([], () => r(require('../pages/course/KangarooCoursePackageEdit'), 'kangarooCoursePackageEdit'));
const kangarooCourseEdit = r => require.ensure([], () => r(require('../pages/course/KangarooCourseEdit'), 'kangarooCourseEdit'));
const contentPackageEdit = r => require.ensure([], () => r(require('../pages/course/ContentPackageEdit')), 'course');
//师训
const training = r => require.ensure([], () => r(require('../pages/course/TrainingPackageList')), 'training');
//活动预约列表
const activity = r => require.ensure([], () => r(require('../pages/course/ActivityList')), 'activity');
//添加编辑师训
const trainingEdit = r => require.ensure([], () => r(require('../pages/course/TrainingEdit')), 'trainingEdit');
//编辑课程
const courseEdit = r => require.ensure([], () => r(require('../pages/course/CourseEdit')), 'courseEdit');
//课程包详情
const coursePackage = r => require.ensure([], () => r(require('../pages/course/CoursePackage')), 'coursePackage');
//师训包详情
const trainingPackage = r => require.ensure([], () => r(require('../pages/course/TrainingPackage')), 'trainingPackage');
//导出课程教案
const exporTeachingPlan = r => require.ensure([], () => r(require('../pages/course/CourseTeachingPlan')), 'exporTeachingPlan');
//导出贝玛课程印刷版-贝玛
const exporCourseContentPrint = r => require.ensure([], () => r(require('../pages/course/beima/Course')), 'exporCourseContentPrint');
//导出贝玛游戏印刷版-贝玛
const exporOutDoorGamesPrint = r => require.ensure([],() => r(require('../pages/course/beima/Games')), 'exporOutDoorGamesPrint');
//导出课程-爱酷
const CourseReportDerive = r => require.ensure([],() => r(require('../pages/course/ikid/Course')), 'CourseReportDerive');
//上传公众号二维码
const weCode = r => require.ensure([],() => r(require('../pages/qrCode/wechatCode')), 'wechatCode');


export default new Router({
    routes: [
    {
        path: '/',
        component: login,
    },
    {
        path: '/main',
        component: main,
        children: [
            //幼儿园管理列表页
            {
                path: '/kgList/:userId',
                name:'kgList',
                component: kgList,
            },
            //幼儿园详情Main
            {
                path: '/kindergartenMain/:id',
                component: kindergartenMain,
                children: [{
                    path: 'kgHome', //园所首页
                    component: kgHome,
                },{
                    path: 'childList', //幼儿管理
                    component: childList,
                },{
                    path: 'exportReport', //数据报告导出
                    component: exportReport,
                },{
                    path: 'checkData', //数据核查
                    component: checkData,
                },{
                    path: 'kgTestReport', //园所报告
                    component: kgTestReport,
                },{
                    path: 'kgHomeNew', //园长身份：园所报告
                    component: kgHomeNew,
                },{
                    path: 'screeningChildren', //园长身份：孩子筛选
                    component: screeningChildren,
                },{
                    path: 'familyReport', //园长身份：家长报告
                    component: familyReport,
                },{
                    path: 'termOutline', //园长身份：课程详情
                    component: termOutline,
                },{
                    path: 'courseContent', //园长身份：课程内容
                    component: courseContent,
                },{
                    path: 'exercisePlan', //园长身份：体格锻炼计划
                    component: exercisePlan,
                },{
                    path: 'teacherManagement', //园长身份：教师管理
                    component: teacherManagement,
                },{
                    path: 'teachingProgram', //园长身份：课程大纲  报告
                    component: teachingProgram,
                },{
                    path:'classHome',//园长身份：班级信息首页
                    component:classHome
                },{
                    path:'gradeHome',//园长身份：年级信息首页
                    component:gradeHome
                }]
            },
            //加盟商管理列表页
            {
                path: '/allianceList',
                component: allianceList,
            },
            //加盟商管理Main
            {
                path: '/allianceMain/:id',
                component: allianceMain,
                children: [{
                    path: 'allianceHome', //加盟商信息
                    component: allianceHome,
                },{
                    path: 'allianceHistoryList', //历史测试
                    component: allianceHistoryList,
                },{
                    path: 'projectSpeed',//项目看板
                    component: projectSpeed,
                },{
                    path: 'projectInformation',//项目详情
                    component: projectInformation,
                },{
                    path: 'resourceTelephone',//资源联系
                    component: resourceTelephone,
                },{
                    path: 'teacherPlatform',//师资平台
                    component: teacherPlatform,
                },{
                    path: 'kdgConnect',//园所沟通
                    component: kdgConnect,
                },{
                    path: 'logInfo',//日志信息
                    component: logInfo,
                },{
                    path: 'addEditKdg',//添加编辑日志
                    component: addEditKdg,
                },{
                    path: 'introduction',//帮助中心简介
                    component: introduction,
                },{
                    path: 'promotionalMaterials',//市场推广资料
                    component: promotionalMaterials,
                },{
                    path: 'governmentInfo',//政府对接资料
                    component: governmentInfo,
                },{
                    path: 'activityScheme',//推广活动方案
                    component: activityScheme,
                },{
                    path: 'planScheme',//会销策划方案
                    component: planScheme,
                },{
                    path: 'testInstruction',//体测实施说明
                    component: testInstruction,
                },{
                    path: 'systemUse',//系统使用说明
                    component: systemUse,
                },{
                    path: 'hardwareEquip',//硬件设备
                    component: hardwareEquip,
                },{
                    path: 'parentMeet',//家长会资料
                    component: parentMeet,
                },{
                    path: 'propagandaMater',//产品宣传材料
                    component: propagandaMater,
                },{
                    path: 'packaging',//产品外包装材料
                    component: packaging,
                }]
            },
            //机构管理列表页
            {
                path: '/agencyList/:userId',
                name:'agencyList',
                component: agencyList

            },
            //机构管理主页
            {
                path: '/agencyHome',
                component: agencyHome,
            },
            //代理管理列表页
            {
                path: '/proxyList/:userId',
                name:'proxyList',
                component: proxyList,
            },
            //代理管理主页
            {
                path: '/proxyHome',
                component: proxyHome,
            },
            //代理+机构：测试员管理
            {
                path: '/testersManagement',
                component: testersManagement,
            },
            //数据导入页
            {
                path: '/importData',
                component: importData,
            },
			//课程包列表
			{
				path: '/course',
				component: course,
			},
			//师训包列表
			{
				path: '/training',
				component: training,
            },
            {
                path: '/kangarooCoursePackage',
                component: kangarooCoursePackage
            },
            {
                path: '/kangarooCourseList',
                component:kangarooCourseList
            },
            {
                path: '/kangarooCoursePackageEdit',
                component: kangarooCoursePackageEdit
            },
            {
                path: '/kangarooCourseEdit',
                component: kangarooCourseEdit
            },
            //课程包师训包详情
			{
				path: '/contentPackageEdit',
				component: contentPackageEdit,
            },

			//活动预约列表
			{
				path: '/activity',
				component: activity,
			},
			//添加编辑师训
			{
				path: '/trainingEdit',
				component: trainingEdit,
			},
			//编辑课程
			{
				path: '/courseEdit',
				component: courseEdit,
			},
			//课程包详情
			{
				path: '/coursePackage',
				component: coursePackage,
			},
			//师训包详情
			{
				path: '/trainingPackage',
				component: trainingPackage,
			},
			//导出课程教案
			{
				path: '/exporTeachingPlan',
				component: exporTeachingPlan,
			},
			//导出课程内容印刷版
			{
				path: '/exporCourseContentPrint',
				component: exporCourseContentPrint,
			},
			//导出户外游戏印刷版
			{
				path: '/exporOutDoorGamesPrint',
				component: exporOutDoorGamesPrint,
            },
            //课程导出-爱酷
            {
                path: '/CourseReportDerive',
                component: CourseReportDerive,
            },
            //其他页
            {
                path: '/other',
                component: other,
            },
            {
                path:'/wechatCode',
                component:weCode
            }
            
        ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js